<template>
    <div  class="form-page">
        <my-form v-model="form" readonly table>
            <my-form-item-group title="查看中标公告">
                <el-form-item label="公告名称" prop="by1" class="table-full-row">
                    {{form.by1}}
                </el-form-item>
                <el-form-item label="招标项目" prop="zbproname" class="table-full-row">
                    {{zbprocode}}--{{zbproname}}
                </el-form-item>
                <el-form-item label="标段名称" prop="bdname" class="table-full-row">
                    {{form.bdname}}
                </el-form-item>
                <el-form-item 
                    label="中标公告类型" 
                    class="table-full-row">
                        <span v-if="form.ggxzcode=='1'||!form.ggxzcode">正常</span>
                        <span v-if="form.ggxzcode=='2'">变更</span>
                </el-form-item>
                <el-form-item label="中标人" prop="zbdwname">
                    {{form.zbdwname}}
                </el-form-item>
                <el-form-item label="统一社会信用代码" prop="zbdworgcode" v-if="isHalf=='true'">
                    {{form.zbdworgcode}}
                </el-form-item>
                <el-form-item label="报价类型" prop="bjlx">
                    <div v-if="form.bjlx==='2'">费率/比率/优惠率/合格率等</div>
                    <div v-if="form.bjlx==='3'">单价</div>
                    <div v-if="form.bjlx==='4'">其他形式</div>
                    <div v-if="form.bjlx==='1'||form.bjlx===''">金额</div>
                </el-form-item>
                <el-form-item label="中标价格" v-if="form.bjlx==='2'||form.bjlx==='3'||form.bjlx==='4'">
                    {{form.zbbj}}
                </el-form-item>
                <el-form-item label="委托价格" v-if="form.bjlx==='2'||form.bjlx==='3'||form.bjlx==='4'">
                    {{form.wtbj}}
                </el-form-item>
                <el-form-item label="中标价格" v-if="form.bjlx==='1'">
                    {{form.zbjg}}{{form.jgdwname}}{{form.bzname}}
                </el-form-item>
                <el-form-item label="委托金额" v-if="form.bjlx==='1'" prop="e_wtje">
                    {{form.e_wtje}}
                </el-form-item> 
                <el-form-item label="节资率" v-if="form.bjlx!=='2'&&form.bjlx!=='3'&&form.bjlx!=='4'" prop="e_jzl">
                    {{form.e_jzl}}
                </el-form-item>
                <el-form-item label="其它说明" prop="qtsm" class="table-full-row">
                    {{form.qtsm}}
                </el-form-item>                
                <el-form-item label="公告内容" prop="zbdwname" class="table-full-row">
                    <div v-html="form.detail"></div>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.fileguid"></my-upload>
                </el-form-item>
            </my-form-item-group>
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            zbproname:'',
            zbprocode:'',
            form:{},
            isHalf:false,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
        
    },
    mounted() {
        var that=this;
        that.isHalf = this.$route.query.isHalf;
        if(this.$route.query.ggcode!=undefined){
            that.$get(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/detail.json`,{ggcode:this.$route.query.ggcode,isXt:this.$route.query.isXt}, (data, res) => {
                that.form=data.model;
                that.zbproname=data.zbproname;
                that.zbprocode=data.zbprocode;
            });
        }
    }
}
</script>

<style scoped lang="scss">

</style>
